import { useQuery } from "@tanstack/react-query";
import getAiParsing from "api/insights/getAiParsing";
import getInsightsData from "api/insights/getInsightsData";

export default function useGetInsights({ queryParams }) {
  const {
    search,
    page,
    perPage,
    sortBy,
    sortDir,
    partnerId,
    brandIds,
    excludeBrandIds,
    categoryId,
    insightful,
    tags,
    keywords,
    sentiments,
  } = queryParams;

  const { data: aiLogic } = useQuery({
    queryKey: ["ai-parse", search],
    queryFn: () => getAiParsing(search),
    enabled: !!search,
    staleTime: Infinity,
  });

  return useQuery({
    queryKey: [
      "insights-data",
      search,
      aiLogic,
      page,
      perPage,
      sortBy,
      sortDir,
      partnerId,
      brandIds,
      excludeBrandIds,
      categoryId,
      insightful,
      tags,
      keywords,
      sentiments,
    ],
    queryFn: () =>
      getInsightsData({
        search,
        aiLogic,
        page,
        perPage,
        sortBy,
        sortDir,
        partnerId,
        brandIds,
        excludeBrandIds,
        categoryId,
        insightful,
        tags,
        keywords,
        sentiments,
      }),
    enabled: !search || (!!search && !!aiLogic),
  });
}
